module.exports = __webpack_public_path__ + "img/logo-opera.3d8f7bcc.svg";